import type { Middleware } from 'redux';
import { SAVE_COUNTER_SUGGESTIONS } from '../../actions/actionTypes/suggestions';
import { getSuggestionCallFrequency } from '../../selectors/trainer';
import { DOMAIN_CALL_ENDED } from '../../actions/actionTypes/domain';
import { getNewSuggestions } from '../../actions/backendCall';
import { getActionType } from '../../utils/action';

const suggestionCallMiddleware: Middleware = store => next => action => {
    const type = getActionType(action);

    switch (type) {
        case DOMAIN_CALL_ENDED: {
            const state = store.getState();

            const suggestionCallFrequency = getSuggestionCallFrequency(state);
            if (suggestionCallFrequency > 0) {
                const { callsAfterLastRequest } = state.callSuggestions;
                if (callsAfterLastRequest >= suggestionCallFrequency - 1) {
                    store.dispatch({
                        type: SAVE_COUNTER_SUGGESTIONS,
                        payload: {
                            callsAfterLastRequest: 0
                        }
                    });

                    setTimeout(() => store.dispatch(getNewSuggestions() as never), 1000);
                } else {
                    store.dispatch({
                        type: SAVE_COUNTER_SUGGESTIONS,
                        payload: {
                            callsAfterLastRequest: callsAfterLastRequest + 1
                        }
                    });
                }
            }
            break;
        }
        default:
    }

    return next(action);
};

export default suggestionCallMiddleware;
